export default __webpack_public_path__ + "static/media/upset.7dcc6ed8.svg";